import { type PropsWithChildren, type ReactNode } from 'react'
import './SheetButton.scss'
import * as S from './SheetButton.styles'
import classNames from 'classnames'
import { translateManager as t } from '../../services/TranslateManager'

type SheetButtonProps = PropsWithChildren<{
  action?: () => void
  icon?: ReactNode
  highlighted?: boolean
  className?: string
  disableClick?: boolean
  testId?: string
  showChangeButton?: boolean
  changeButtonText?: string
  onChangeButtonClick?: () => void
  allIsClickable?: boolean
  promo?: boolean
}>

function SheetButton({
  action,
  icon,
  highlighted,
  children,
  className,
  disableClick,
  testId,
  showChangeButton,
  changeButtonText,
  onChangeButtonClick,
  allIsClickable = true,
  promo,
}: SheetButtonProps) {
  const buttonClass = classNames('sheet-button', className, {
    highlighted,
    'disable-click': disableClick,
    'all-is-clickable': allIsClickable,
  })
  const buttonIconClass = classNames('button-icon', { highlighted })
  const changeClass = classNames('change-button', { visible: showChangeButton })
  return (
    <S.SheetButton
      className={buttonClass}
      onClick={disableClick ? undefined : action}
      data-testid={testId}
      $promo={promo}
    >
      {icon && <div className={buttonIconClass}>{icon}</div>}
      <S.Text
        $promo={promo}
        $highlighted={highlighted}
        data-testid={`${testId}-text`}
      >
        {children}
      </S.Text>
      <div className={changeClass} onClick={onChangeButtonClick}>
        {changeButtonText || t.get('order.checkout.change_info')}
      </div>
    </S.SheetButton>
  )
}

export default SheetButton
